import { Component } from '@angular/core';


@Component({
	selector: 'finance-awards-trimester-view-part',
	standalone: true,
	templateUrl: './finance-awards-trimester-view.part.html',
	styleUrls: ['./finance-awards-trimester-view.part.scss'],
})
export class FinanceAwardsTrimesterViewPart {
}